// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconUserCircle = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M21.6 11.9999C21.6 17.3018 17.302 21.5999 12 21.5999C6.69809 21.5999 2.40002 17.3018 2.40002 11.9999C2.40002 6.69797 6.69809 2.3999 12 2.3999C17.302 2.3999 21.6 6.69797 21.6 11.9999ZM15.4389 8.72786C15.4389 6.89635 13.8927 5.3999 12.0003 5.3999C10.1079 5.3999 8.56176 6.89635 8.56176 8.72786C8.56176 10.5594 10.1079 12.0558 12.0003 12.0558C13.8927 12.0558 15.4389 10.5594 15.4389 8.72786Z',
      fill: 'current'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.40002 19.1999C5.86119 18.6834 8.02107 16.3066 8.65403 16.3066H15.3464C16.2636 16.3066 18.136 18.2768 18.6 18.9713M21.6 11.9999C21.6 17.3018 17.302 21.5999 12 21.5999C6.69809 21.5999 2.40002 17.3018 2.40002 11.9999C2.40002 6.69797 6.69809 2.3999 12 2.3999C17.302 2.3999 21.6 6.69797 21.6 11.9999ZM15.4389 8.72786C15.4389 6.89635 13.8927 5.3999 12.0003 5.3999C10.1079 5.3999 8.56176 6.89635 8.56176 8.72786C8.56176 10.5594 10.1079 12.0558 12.0003 12.0558C13.8927 12.0558 15.4389 10.5594 15.4389 8.72786Z',
      stroke: 'current'
    })
  );

export { IconUserCircle };
